/* tslint:disable */
/* eslint-disable */
/**
 * Carrot Config Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The "EmailJobType" Enum
 * @export
 */
export const EmailJobType = {
    ActionReport: 'ACTION_REPORT',
    TenantActionReport: 'TENANT_ACTION_REPORT',
    ReportHouseholdCustomers: 'REPORT_HOUSEHOLD_CUSTOMERS'
};
export function instanceOfEmailJobType(value) {
    for (const key in EmailJobType) {
        if (Object.prototype.hasOwnProperty.call(EmailJobType, key)) {
            if (EmailJobType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function EmailJobTypeFromJSON(json) {
    return EmailJobTypeFromJSONTyped(json, false);
}
export function EmailJobTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EmailJobTypeToJSON(value) {
    return value;
}
//# sourceMappingURL=EmailJobType.js.map